
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bantuan/umum",
      function () {
        return require("private-next-pages/bantuan/umum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bantuan/umum"])
      });
    }
  